module.exports = __webpack_public_path__ + "media/images/flags/IN-a61ac1fda6669c7f546a23339af4a292.svg";